import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent } from './layouts/main/main.component';

import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPwdComponent } from './forgot-pwd/forgot-pwd.component';

import { ErrorComponent } from './layouts/error/error.component';
import { ForbiddenComponent } from './layouts/forbidden/forbidden.component';

import { UserRouteAccessService } from './shared/auth/user-route-access-service';
//import { MoniteringComponent } from './monitering/monitering.component';
//import { StorageMonitorComponent } from './storage-monitor/storage-monitor.component';
import { AdminGuard } from './shared/auth/admin.guard';
export const routes: Routes = [{
    path: 'workflows/shared/:token',
    loadComponent: () => import('./workflow/workflow.component').then(c => c.WorkflowComponent)
}, {
    path: '',
    component: MainComponent,
    canActivate: [UserRouteAccessService],
    children: [
        { path: '', redirectTo: '/home', pathMatch: 'full' },
        { path: 'home', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
        { path: 'help', loadChildren: () => import('./help/help.module').then(m => m.HelpModule) },
        { path: 'profile', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
        { path: 'data', loadChildren: () => import('./data/data.module').then(m => m.DataModule) },
        { path: 'executions', loadChildren: () => import('./executions/executions.module').then(m => m.ExecutionsModule) },
        { path: 'block', loadChildren: () => import('./block/block.module').then(m => m.BlockModule) },
        { path: 'flow', loadChildren: () => import('./flow/flow.module').then(m => m.FlowModule) },
        { path: 'workflows', loadComponent: () => import('./workflow/workflow.component').then(c => c.WorkflowComponent) },
        { path: 'workflows/:flowId', loadComponent: () => import('./workflow/workflow.component').then(c => c.WorkflowComponent) },
        { path: 'workflow', redirectTo: 'workflows', pathMatch: 'full' },
        { path: 'shared-links', loadComponent: () => import('./shared-flow-links/shared-links.component').then(c => c.SharedLinksComponent) },
        { path: 'project', loadChildren: () => import('./project/project.module').then(m => m.ProjectModule) },
        { path: 'category', loadChildren: () => import('./category/category.module').then(m => m.CategoryModule) },
        { path: 'market', loadChildren: () => import('./market-place/market-place.module').then(m => m.MarketPlaceModule) },
        { path: 'image-registry', loadChildren: () => import('./image-registry/image-registry.module').then(m => m.ImageRegistryModule) },
        { path: 'model-registry', loadChildren: () => import('./model-registry/model-registry.module').then(m => m.ModelRegistryModule) },
        { path: 'streamlit' , loadChildren: () => import('./streamlit/streamlit.module').then(m => m.StreamlitModule)},
        { path: 'audit-logs', loadChildren: () => import('./audit-logs/audit-logs.module').then(m => m.AuditLogsModule) },
        { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AdminGuard] },
        { path: 'active-users', loadComponent: () => import('./monitering/monitering.component').then(c => c.MoniteringComponent), canActivate: [AdminGuard] },
        { path: 'storage-monitor', loadComponent: () => import('./storage-monitor/storage-monitor.component').then(c => c.StorageMonitorComponent), canActivate: [AdminGuard] },
        { path: 'streamlit', loadComponent: () => import('./streamlit/streamlit.component').then(c => c.StreamlitComponent), canActivate: [AdminGuard] },
        { path: 'streamlit/create', loadComponent: () => import('./streamlit/streamlit-form/streamlit-form.component').then(c => c.StreamlitFormComponent), canActivate: [AdminGuard] },
        { path: 'streamlit/edit/:id', loadComponent: () => import('./streamlit/streamlit-form/streamlit-form.component').then(c => c.StreamlitFormComponent), canActivate: [AdminGuard] },
        { path: 'model-work-flow', loadComponent: () => import('./model-work-flow/model-work-flow.component').then(c => c.ModelWorkFlowComponent), canActivate: [AdminGuard] },
        { path: 'approval-request', loadComponent: () => import('./approval-request/approval-request.component') .then(m => m.ApprovalRequestComponent) },
        { path: 'webhooks', loadComponent: () => import('./webhooks/webhooks.component').then(c => c.WebhooksComponent) }
    ]
}, {
    path: 'login', component: LoginComponent
}, {
    path: 'signup', component: SignupComponent
}, {
    path: 'forgot-pwd', component: ForgotPwdComponent
}, {
    path: 'error', component: ErrorComponent
}, {
    path: 'forbidden', component: ForbiddenComponent
}, {
    path: 'reset-password/:userId/:resetCode', component: ForgotPwdComponent
}
,{
    path: 'reset-password/:userId/:resetCode/:projectId', component: ForgotPwdComponent
},
{
    // Outside MainComponent on purpose: the dashboard opens in its own tab without the
    // header and side navigation.
    path: 'dashboard-fullscreen/:executionId',
    loadComponent: () => import('./components/execution-list/dashboard-fullscreen/dashboard-fullscreen.component')
        .then(c => c.DashboardFullscreenComponent),
    canActivate: [UserRouteAccessService]   
}, {
    path: '**', redirectTo: '/home', pathMatch: 'full'
}];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
  	exports: [RouterModule]
})

export class AppRoutingModule { }
